import { NgModule } from '@angular/core';
import { DateMomentPipe } from './date-moment.pipe';
import { StringFilterPipe } from './filter-pipe';
import { OrderByPipe } from './order-by.pipe';
import { WidgetBorderStylePipe } from './widget-border.pipe';

@NgModule({
    imports: [DateMomentPipe, OrderByPipe, StringFilterPipe, WidgetBorderStylePipe],
    exports: [DateMomentPipe, OrderByPipe, StringFilterPipe, WidgetBorderStylePipe],
})
export class PipesModule { }
